// ======================================================================
// File Name       : service
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function getRecordList(params, pathOptions) {
  return commonCallApi({
    path: pathOptions.apiPath,
    drillServer: pathOptions.drillServer,
    data: { ...params },
  });
}

export function getServiceList(searchInfo) {
  return commonCallApi({
    path: 'service/GetList',
    data: searchInfo,
  });
}

export function systemDownloadForm(params) {
  return commonCallApi({
    path: 'usage/GetSystemUsageList',
    data: { ...params },
    enterpriseId: 1,
  });
}

export function getServiceNotificationList(param) {
  return commonCallApi({
    path: 'notice/GetList',
    data: { ...param },
  });
}

export function registerEditServiceNotification(param) {
  return commonCallApi({
    path: 'notice/Edit',
    data: { ...param },
  });
}
